import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  pr: 2,
  pb: 2,
};

export const upperSection: SxStyle = {
  background: (p) => p.palette.common.white,
  borderBottomWidth: '1px',
  borderBottomStyle: 'dashed',
  borderBottomColor: (p) => p.palette.grey[400],
  mb: 1,
  pb: 1,
};

export const content: SxStyle = {
  px: 2,
};

export const overview: SxStyle = {
  px: 2,
  borderBottomWidth: '1px',
  borderBottomStyle: 'dashed',
  borderBottomColor: (p) => p.palette.grey[400],
  pb: 1,
};

export const text: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightLight,
};

export const title: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightBold,
};

export const divider: SxStyle = {
  borderTopWidth: '1px',
  borderTopStyle: 'dashed',
  borderTopColor: (p) => p.palette.grey[300],
  width: '100%',
  my: 1,
};
